"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelBox = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const material_1 = require("@mui/material");
const Typo_1 = require("../Typo/Typo");
const styled_1 = __importDefault(require("@emotion/styled"));
const StyledBox = (0, styled_1.default)(material_1.Box) `
  align-items: center;
  border-radius: 4px;
  display: flex;
  height: 48px;
  justify-content: center;
  line-height: 3px;
  width: 192px;
`;
function LabelBox({ label, background, color, }) {
    return ((0, jsx_runtime_1.jsx)(StyledBox, Object.assign({ bgcolor: background }, { children: (0, jsx_runtime_1.jsx)(Typo_1.Typo, Object.assign({ variant: "button", color: color, fontWeight: 500 }, { children: label })) })));
}
exports.LabelBox = LabelBox;
